// Shared voice/accessibility settings (persist for the session) + TTS playback queue.
import { API } from "./api";

const KEY = "dk_voice";
export const getVoice = () => sessionStorage.getItem(KEY) || "female";
export const setVoice = (v) => { sessionStorage.setItem(KEY, v); window.dispatchEvent(new CustomEvent("dk-voice", { detail: v })); };

export const chunkText = (text, max = 3500) => {
  const out = []; let cur = "";
  for (const s of (text || "").replace(/\s+/g, " ").split(/(?<=[.!?])\s+/)) {
    if ((cur + " " + s).length > max && cur) { out.push(cur.trim()); cur = s; } else cur += " " + s;
  }
  if (cur.trim()) out.push(cur.trim());
  return out;
};

export const getLang = () => localStorage.getItem("dkf_lang") || "en";

let configPromise = null;
export const fetchTtsConfig = () => (configPromise ||= fetch(`${API}/tts/config`).then((r) => r.json()).catch(() => ({ native_voices: false, native_languages: [] })));

export const fetchTts = async (text, voice = getVoice(), lang = getLang()) => {
  const r = await fetch(`${API}/tts`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ text, voice, lang }) });
  if (!r.ok) throw new Error((await r.json().catch(() => ({}))).detail || "Audio unavailable");
  const { url } = await r.json();
  return `${API.replace(/\/api$/, "")}${url}`;
};

// Sequential player: speak(chunks) → resolves when finished; stop() halts.
export const createSpeaker = () => {
  let audio = null, stopped = false;
  const stop = () => { stopped = true; if (audio) { audio.pause(); audio.src = ""; audio = null; } };
  const speak = async (text, voice, onState) => {
    stopped = false;
    const chunks = chunkText(text);
    for (let i = 0; i < chunks.length && !stopped; i++) {
      onState?.({ loading: true, index: i, total: chunks.length });
      const src = await fetchTts(chunks[i], voice, getLang());
      if (stopped) return;
      await new Promise((resolve, reject) => {
        audio = new Audio(src);
        audio.onended = resolve; audio.onerror = () => reject(new Error("Playback failed"));
        onState?.({ loading: false, playing: true, index: i, total: chunks.length });
        audio.play().catch(reject);
      });
    }
    onState?.({ playing: false, loading: false });
  };
  return { speak, stop };
};
